module.exports = __webpack_public_path__ + "static/media/calendar-multiple.9161492e.png";